import React from "react";
import { Navigate, Routes, Route } from "react-router-dom";
import { route } from "./route";
import Login from "../pages/login/login";
// import Join from "../pages/join/join";
// import JoinComplete from "../pages/join/joinComplete";
import Home from "../pages/home/home";
import ShoppingProduct from "../pages/shopping/shoppingProduct/shoppingProduct";
import ShoppingProductCreateBasic from "./../pages/shopping/shoppingProduct/shoppingProductCreateBasic";
import ShoppingProductCreateDetail from "./../pages/shopping/shoppingProduct/shoppingProductCreateDetail";
import ShoppingProductCreateChapter from "./../pages/shopping/shoppingProduct/shoppingProductCreateChapter";
import ShoppingProductCreateImage from "./../pages/shopping/shoppingProduct/shoppingProductCreateImage";
import ShoppingProductCreateEtc from "./../pages/shopping/shoppingProduct/shoppingProductCreateEtc";
import ShoppingProductChapter from "./../pages/shopping/shoppingProduct/shoppingProductChapter";
import ShoppingProductChapterCreate from "./../pages/shopping/shoppingProduct/shoppingProductChapterCreate";
import ShoppingSell from "../pages/shopping/shoppingSell/shoppingSell";
import ShoppingSellDetail from "./../pages/shopping/shoppingSell/shoppingSellDetail";
import WritingLink from "./../pages/crewOnly/writingLink/writingLink";
import WritingLinkDetail from "./../pages/crewOnly/writingLink/writingLinkDetail";
import CommunityManagement from "./../pages/community/communityManagement/communityManagement";
import FirstVisit from "../pages/community/firstVisit/firstVisit";
import FirstVisitCreate from "./../pages/community/firstVisit/firstVisitCreate";
import FirstVisitEdit from "./../pages/community/firstVisit/firstVisitEdit";
import ShoppingMembershipProduct from "./../pages/shopping/shoppingMembershipProduct/shoppingMembershipProduct";
import ShoppingMembershipSell from "./../pages/shopping/shoppingMembershipSell/shoppingMembershipSell";
import ShoppingReview from "./../pages/shopping/shoppingReview/shoppingReview";
import UserInfo from "./../pages/user/userInfo/userInfo";
import UserMembershipInfo from "./../pages/user/userMembershipInfo/userMembershipInfo";
import UserAdmin from "./../pages/user/userAdmin/userAdmin";
import UserPurchaseLimit from "./../pages/user/userPurchaseLimit/userPurchaseLimit";
import UserWithdraw from "./../pages/user/userWithdraw/userWithdraw";
import StatisticsHome from "./../pages/statistics/statisticsHome/statisticsHome";
import StatisticsSales from "./../pages/statistics/statisticsSales/statisticsSales";
import StatisticsPeriod from "./../pages/statistics/statisticsPeriod/statisticsPeriod";
import StatisticsInflowSite from "./../pages/statistics/statisticsInflowSite/statisticsInflowSite";
import StatisticsInflowSearch from "./../pages/statistics/statisticsInflowSearch/statisticsInflowSearch";
import StatisticsVisitor from "./../pages/statistics/statisticsVisitor/statisticsVisitor";
import StatisticsMostVisited from "../pages/statistics/statisticsMostVisited/statisticsMostVisited";
import StatisticsTime from "./../pages/statistics/statisticsTime/statisticsTime";
import StatisticsGenderAge from "./../pages/statistics/statisticsGenderAge/statisticsGenderAge";
import StatisticsAnalysis from "./../pages/statistics/statisticsAnalysis/statisticsAnalysis";
import StatisticsCancel from "../pages/statistics/statisticsCancel/statisticsCancel";
import OperationCoupon from "./../pages/operation/operationCoupon/operationCoupon";
import OperationMessageAlarm from "./../pages/operation/operationMessage/operationMessageAlarm";
import OperationNotice from "./../pages/operation/operationNotice/operationNotice";
import OperationPoint from "./../pages/operation/operationPoint/operationPoint";
import OperationLevel from "./../pages/operation/operationLevel/operationLevel";
import OperationFaq from "./../pages/operation/operationFaq/operationFaq";
import OperationAsk from "./../pages/operation/operationAsk/operationAsk";
import OperationPopupBanner from "./../pages/operation/operationPopupBanner/operationPopupBanner";
import OperationTerms from "./../pages/operation/operationTerms/operationTerms";
import OperationData from "./../pages/operation/operationData/operationData";
import OperationConsult from "./../pages/operation/operationConsult/operationConsult";
import SecretDetail from "./../pages/secret/secretDetail/secretDetail";
import SecretQna from "./../pages/secret/secretQna/secretQna";
import KnowledgeBanner from "./../pages/knowledge/knowledgeBanner/knowledgeBanner";
import KnowledgeVu from "./../pages/knowledge/knowledgeVu/knowledgeVu";
import KnowledgeCurriculum from "./../pages/knowledge/knowledgeCurriculum/knowledgeCurriculum";
import KnowledgeFirstVisit from "./../pages/knowledge/knowledgeFirstVisit/knowledgeFirstVisit";
import OperationFaqCreate from "./../pages/operation/operationFaq/operationFaqCreate";
import OperationFaqDetail from "./../pages/operation/operationFaq/operationFaqDetail";
import OperationFaqEdit from "./../pages/operation/operationFaq/operationFaqEdit";
import OperationAskDetail from "./../pages/operation/operationAsk/operationAskDetail";
import OperationNoticeDetail from "./../pages/operation/operationNotice/operationNoticeDetail";
import OperationNoticeCreate from "./../pages/operation/operationNotice/operationNoticeCreate";
import OperationNoticeEdit from "./../pages/operation/operationNotice/operationNoticeEdit";
import KnowledgeCurriculumCreate from "./../pages/knowledge/knowledgeCurriculum/knowledgeCurriculumCreate";
import KnowledgeVuCreate from "./../pages/knowledge/knowledgeVu/knowledgeVuCreate";
import SecretQnaDetail from "./../pages/secret/secretQna/secretQnaDetail";
import SecretQnaEdit from "./../pages/secret/secretQna/secretQnaEdit";
import SecretArchive from "./../pages/secret/secretArchive/secretArchive";
import SecretArchiveDetail from "./../pages/secret/secretArchive/secretArchiveDetail";
import SecretArchiveEdit from "./../pages/secret/secretArchive/secretArchiveEdit";
import CommunityManagementDetail from "./../pages/community/communityManagement/communityManagementDetail";
import OperationPopupBannerCreate from "./../pages/operation/operationPopupBanner/operationPopupBannerCreate";
import OperationPopupBannerEdit from "./../pages/operation/operationPopupBanner/operationPopupBannerEdit";
import OperationMessageEmail from "./../pages/operation/operationMessage/operationMessageEmail";
import OperationMessageSms from "./../pages/operation/operationMessage/operationMessageSms";
import OperationMessageAlarmDetail from "./../pages/operation/operationMessage/operationMessageAlarmDetail";
import OperationMessageSmsDetail from "./../pages/operation/operationMessage/operationMessageSmsDetail";
import OperationCouponCreate from "./../pages/operation/operationCoupon/operationCouponCreate";
import OperationCouponEdit from "./../pages/operation/operationCoupon/operationCouponEdit";
import UserWithdrawDetail from "./../pages/user/userWithdraw/userWithdrawDetail";
import ShoppingMembershipProductLms from "../pages/shopping/shoppingMembershipProduct/shoppingMembershipProductLms";
import ShoppingMembershipProductCreate from "./../pages/shopping/shoppingMembershipProduct/shoppingMembershipProductCreate";
import ShoppingMembershipSellDetail from "./../pages/shopping/shoppingMembershipSell/shoppingMembershipSellDetail";
import UserInfoDetail from "./../pages/user/userInfo/userInfoDetail";
import UserMembershipInfoDetail from "./../pages/user/userMembershipInfo/userMembershipInfoDetail";
import UserAdminDetail from "./../pages/user/userAdmin/userAdminDetail";
import UserAdminInvite from "./../pages/user/userAdmin/userAdminInvite";
import WritingCrewGuide from "../pages/crewOnly/writingGuide/writingGuide";
import WritingCrewGuideCreate from "../pages/crewOnly/writingGuide/writingGuideCreate";
import WritingCrewGuideEdit from "../pages/crewOnly/writingGuide/writingGuideEdit";
import SecretDetailCurriculum from "./../pages/secret/secretDetail/secretDetailCurriculum";
import ShoppingProductChapterEdit from "./../pages/shopping/shoppingProduct/shoppingProductChapterEdit";
import KnowledgeVuEdit from "../pages/knowledge/knowledgeVu/knowledgeVuEdit";
import KnowledgeCurriculumEdit from "../pages/knowledge/knowledgeCurriculum/knowledgeCurriculumEdit";
import ShoppingMembershipProductEdit from "../pages/shopping/shoppingMembershipProduct/shoppingMembershipProductEdit";
import ShoppingProductEditBasic from "./../pages/shopping/shoppingProduct/shoppingProductEditBasic";
import ShoppingProductEditDetail from "./../pages/shopping/shoppingProduct/shoppingProductEditDetail";
import ShoppingProductEditChapter from "./../pages/shopping/shoppingProduct/shoppingProductEditChapter";
import ShoppingProductEditImage from "./../pages/shopping/shoppingProduct/shoppingProductEditImage";
import ShoppingProductEditEtc from "./../pages/shopping/shoppingProduct/shoppingProductEditEtc";
import HomeEmpty from "../pages/home/homeEmpty";
import SecretDetailImage from "./../pages/secret/secretDetail/secretDetailImage";
import ShoppingMembershipProductLmsDetail from "./../pages/shopping/shoppingMembershipProduct/shoppingMembershipProductLmsDetail";
import ShoppingMembershipProductLmsCurriculum from "./../pages/shopping/shoppingMembershipProduct/shoppingMembershipProductLmsCurriculum";
import ShoppingMembershipProductLmsImage from "./../pages/shopping/shoppingMembershipProduct/shoppingMembershipProductLmsImage";
import UserMembershipWaitingList from "../pages/user/userMembershipWaitingList/userMembershipWaitingList";
import UserPDFApplicationList from "../pages/user/userPDFApplicationList/userPDFApplicationList";
import UserMembershipWaitingListDetail from "../pages/user/userMembershipWaitingList/userMembershipWaitingListDetail";
import UserPDFApplicationListDetail from "../pages/user/userPDFApplicationList/userPDFApplicationListDetail";

const Router = () => {
  return (
    <Routes>
      <Route path="*" element={<Navigate to={route.default} replace />} />

      {/* ---------- 기본 ---------- */}
      <Route path={route.default} element={<Login />} />

      {/* ---------- 로그인/회원가입 ---------- */}
      {/* 로그인 */}
      <Route path={route.login} element={<Login />} />
      {/* 회원가입 */}
      {/* <Route path={route.join} element={<Join />} /> */}
      {/* <Route path={route.join_complete} element={<JoinComplete />} /> */}

      {/* ---------- 홈 ---------- */}
      <Route path={route.home} element={<Home />} />
      <Route path={route.home_empty} element={<HomeEmpty />} />

      {/* ---------- 쇼핑 ---------- */}
      {/* 상품관리 */}
      <Route path={route.shopping_product} element={<ShoppingProduct />} />
      <Route
        path={route.shopping_product_create_basic}
        element={<ShoppingProductCreateBasic />}
      />
      <Route
        path={route.shopping_product_create_detail}
        element={<ShoppingProductCreateDetail />}
      />
      <Route
        path={route.shopping_product_create_chapter}
        element={<ShoppingProductCreateChapter />}
      />
      <Route
        path={route.shopping_product_create_image}
        element={<ShoppingProductCreateImage />}
      />
      <Route
        path={route.shopping_product_create_etc}
        element={<ShoppingProductCreateEtc />}
      />

      <Route
        path={`${route.shopping_product_edit_basic}/:id`}
        element={<ShoppingProductEditBasic />}
      />
      <Route
        path={`${route.shopping_product_edit_detail}/:id`}
        element={<ShoppingProductEditDetail />}
      />
      <Route
        path={`${route.shopping_product_edit_chapter}/:id`}
        element={<ShoppingProductEditChapter />}
      />
      <Route
        path={`${route.shopping_product_edit_image}/:id`}
        element={<ShoppingProductEditImage />}
      />
      <Route
        path={`${route.shopping_product_edit_etc}/:id`}
        element={<ShoppingProductEditEtc />}
      />

      <Route
        path={`${route.shopping_product_chapter}/:id`}
        element={<ShoppingProductChapter />}
      />
      <Route
        path={`${route.shopping_product_chapter_create}/:id`}
        element={<ShoppingProductChapterCreate />}
      />
      <Route
        path={`${route.shopping_product_chapter_edit}/:id`}
        element={<ShoppingProductChapterEdit />}
      />
      {/* 판매관리 */}
      <Route path={route.shopping_sell} element={<ShoppingSell />} />
      <Route
        path={`${route.shopping_sell_detail}/:type/:id`}
        element={<ShoppingSellDetail />}
      />

      {/* 멤버십 상품관리 */}
      <Route
        path={route.shopping_membership_product}
        element={<ShoppingMembershipProduct />}
      />
      <Route
        path={route.shopping_membership_product_create}
        element={<ShoppingMembershipProductCreate />}
      />
      <Route
        path={`${route.shopping_membership_product_edit}/:id`}
        element={<ShoppingMembershipProductEdit />}
      />
      <Route
        path={route.shopping_membership_product_lms}
        element={<ShoppingMembershipProductLms />}
      />
      <Route
        path={`${route.shopping_membership_product_lms_detail}/:id`}
        element={<ShoppingMembershipProductLmsDetail />}
      />
      <Route
        path={`${route.shopping_membership_product_lms_curriculum}/:id`}
        element={<ShoppingMembershipProductLmsCurriculum />}
      />
      <Route
        path={`${route.shopping_membership_product_lms_image}/:id`}
        element={<ShoppingMembershipProductLmsImage />}
      />

      {/* 멤버십 판매관리 */}
      <Route
        path={route.shopping_membership_sell}
        element={<ShoppingMembershipSell />}
      />
      <Route
        path={`${route.shopping_membership_sell_detail}/:type/:id`}
        element={<ShoppingMembershipSellDetail />}
      />
      {/* 후기관리 */}
      <Route path={route.shopping_review} element={<ShoppingReview />} />

      {/* ---------- 회원관리 ---------- */}
      {/* 일반회원 관리 */}
      <Route path={route.user_info} element={<UserInfo />} />
      <Route
        path={`${route.user_info_detail}/:id`}
        element={<UserInfoDetail />}
      />
      {/* 멤버십 회원정보 */}
      <Route
        path={route.user_membership_info}
        element={<UserMembershipInfo />}
      />
      <Route
        path={`${route.user_membership_info_detail}/:id`}
        element={<UserMembershipInfoDetail />}
      />
      {/* 멤버십 대기명단 */}
      <Route
        path={route.user_membership_waiting_list}
        element={<UserMembershipWaitingList />}
      />
      <Route
        path={`${route.user_membership_waiting_list_detail}/:id`}
        element={<UserMembershipWaitingListDetail />}
      />
      {/* 무료 PDF 신청 명단 */}
      <Route
        path={route.user_pdf_application_list}
        element={<UserPDFApplicationList />}
      />
      <Route
        path={`${route.user_pdf_application_list_detail}/:id`}
        element={<UserPDFApplicationListDetail />}
      />
      {/* 운영진 설정 */}
      <Route path={route.user_admin} element={<UserAdmin />} />
      <Route
        path={`${route.user_admin_detail}/:id`}
        element={<UserAdminDetail />}
      />
      <Route path={route.user_admin_invite} element={<UserAdminInvite />} />
      {/* 구매제한 회원 */}
      <Route path={route.user_purchase_limit} element={<UserPurchaseLimit />} />
      {/* 탈퇴 회원 */}
      <Route path={route.user_withdraw} element={<UserWithdraw />} />
      <Route
        path={`${route.user_withdraw_detail}/:id`}
        element={<UserWithdrawDetail />}
      />

      {/* ---------- 통계 ---------- */}
      {/* 홈 */}
      <Route path={route.statistics_home} element={<StatisticsHome />} />
      {/* 매출 */}
      <Route path={route.statistics_sales} element={<StatisticsSales />} />
      {/* 기간별 분석 */}
      <Route path={route.statistics_period} element={<StatisticsPeriod />} />
      {/* 유입 사이트 */}
      <Route
        path={route.statistics_inflow_site}
        element={<StatisticsInflowSite />}
      />
      {/* 유입 검색어 */}
      <Route
        path={route.statistics_inflow_search}
        element={<StatisticsInflowSearch />}
      />
      {/* 방문자 */}
      <Route path={route.statistics_visitor} element={<StatisticsVisitor />} />
      {/* 많이 방문한 페이지 */}
      <Route
        path={route.statistics_most_visited}
        element={<StatisticsMostVisited />}
      />
      {/* 시간대별 조회수 */}
      <Route path={route.statistics_time} element={<StatisticsTime />} />
      {/* 성별·연령별 조회수 */}
      <Route
        path={route.statistics_gender_age}
        element={<StatisticsGenderAge />}
      />
      {/* 멤버십 분석 */}
      <Route
        path={route.statistics_analysis}
        element={<StatisticsAnalysis />}
      />
      {/* 멤버십 해지분석 */}
      <Route path={route.statistics_cancel} element={<StatisticsCancel />} />

      {/* ---------- 운영 관리 ---------- */}
      {/* 쿠폰 */}
      <Route path={route.operation_coupon} element={<OperationCoupon />} />
      <Route
        path={route.operation_coupon_create}
        element={<OperationCouponCreate />}
      />
      <Route
        path={`${route.operation_coupon_edit}/:id`}
        element={<OperationCouponEdit />}
      />
      {/* 메시지 보내기 */}
      <Route
        path={route.operation_message}
        element={<OperationMessageAlarm />}
      />
      <Route
        path={route.operation_message_alarm}
        element={<OperationMessageAlarm />}
      />
      <Route
        path={`${route.operation_message_alarm_detail}/:type`}
        element={<OperationMessageAlarmDetail />}
      />
      <Route
        path={route.operation_message_email}
        element={<OperationMessageEmail />}
      />
      <Route
        path={route.operation_message_sms}
        element={<OperationMessageSms />}
      />
      <Route
        path={`${route.operation_message_sms_detail}/:type`}
        element={<OperationMessageSmsDetail />}
      />
      {/* 공지사항 관리 */}
      <Route path={route.operation_notice} element={<OperationNotice />} />
      <Route
        path={`${route.operation_notice_detail}/:id`}
        element={<OperationNoticeDetail />}
      />
      <Route
        path={route.operation_notice_create}
        element={<OperationNoticeCreate />}
      />
      <Route
        path={`${route.operation_notice_edit}/:id`}
        element={<OperationNoticeEdit />}
      />
      {/* 포인트 관리 */}
      <Route path={route.operation_point} element={<OperationPoint />} />
      {/* 레벨 설정 관리 */}
      <Route path={route.operation_level} element={<OperationLevel />} />
      {/* 자주 묻는 질문 관리 */}
      <Route path={route.operation_faq} element={<OperationFaq />} />
      <Route
        path={`${route.operation_faq_detail}/:id`}
        element={<OperationFaqDetail />}
      />
      <Route
        path={route.operation_faq_create}
        element={<OperationFaqCreate />}
      />
      <Route
        path={`${route.operation_faq_edit}/:id`}
        element={<OperationFaqEdit />}
      />
      {/* 1:1 문의 내역 관리 */}
      <Route path={route.operation_ask} element={<OperationAsk />} />
      <Route
        path={`${route.operation_ask_detail}/:id`}
        element={<OperationAskDetail />}
      />
      {/* 팝업/배너 관리 */}
      <Route
        path={route.operation_popup_banner}
        element={<OperationPopupBanner />}
      />
      <Route
        path={route.operation_popup_banner_create}
        element={<OperationPopupBannerCreate />}
      />
      <Route
        path={`${route.operation_popup_banner_edit}/:id`}
        element={<OperationPopupBannerEdit />}
      />
      {/* 약관 관리 */}
      <Route path={route.operation_terms} element={<OperationTerms />} />
      {/* 데이터 연결 */}
      <Route path={route.operation_data} element={<OperationData />} />
      {/* 상담채널 연동 */}
      <Route path={route.operation_consult} element={<OperationConsult />} />

      {/* ---------- 일급비밀 관리 ---------- */}
      {/* 일급비밀 상세페이지 */}
      <Route path={route.secret_detail} element={<SecretDetail />} />
      <Route
        path={route.secret_detail_curriculum}
        element={<SecretDetailCurriculum />}
      />
      <Route path={route.secret_detail_image} element={<SecretDetailImage />} />
      {/* 자료창고 관리 (경로 우선 매칭을 위해 QnA보다 위에 배치) */}
      <Route path={route.secret_archive} element={<SecretArchive />} />
      <Route
        path={`${route.secret_archive_detail}/:id`}
        element={<SecretArchiveDetail />}
      />
      <Route
        path={`${route.secret_archive_edit}/:id`}
        element={<SecretArchiveEdit />}
      />
      {/* 멤버십 QnA 관리 */}
      <Route path={route.secret_qna} element={<SecretQna />} />
      <Route
        path={`${route.secret_qna_detail}/:id`}
        element={<SecretQnaDetail />}
      />
      <Route
        path={`${route.secret_qna_edit}/:id`}
        element={<SecretQnaEdit />}
      />

      {/* ---------- 지식상점 관리 ---------- */}
      {/* 지식상점 홈 배너 */}
      <Route path={route.knowledge_banner} element={<KnowledgeBanner />} />
      {/* Vu: 관리 */}
      <Route path={route.knowledge_vu} element={<KnowledgeVu />} />
      <Route path={route.knowledge_vu_create} element={<KnowledgeVuCreate />} />
      <Route
        path={`${route.knowledge_vu_edit}/:id`}
        element={<KnowledgeVuEdit />}
      />
      {/* 커리큘럼 관리 */}
      <Route
        path={route.knowledge_curriculum}
        element={<KnowledgeCurriculum />}
      />
      <Route
        path={route.knowledge_curriculum_create}
        element={<KnowledgeCurriculumCreate />}
      />
      <Route
        path={`${route.knowledge_curriculum_edit}/:id`}
        element={<KnowledgeCurriculumEdit />}
      />
      {/* 첫 방문이라면? 관리 */}
      <Route
        path={route.knowledge_first_visit}
        element={<KnowledgeFirstVisit />}
      />

      {/* ---------- 커뮤니티 관리 ---------- */}
      {/* 커뮤니티 관리 */}
      <Route
        path={route.community_management}
        element={<CommunityManagement />}
      />
      <Route
        path={`${route.community_management_detail}/:id`}
        element={<CommunityManagementDetail />}
      />
      {/* 라이팅크루가 처음이라면? */}
      <Route path={route.community_first} element={<FirstVisit />} />
      <Route
        path={route.community_first_create}
        element={<FirstVisitCreate />}
      />
      <Route path={route.community_first_edit} element={<FirstVisitEdit />} />

      {/* ---------- 멤버십 전용 관리 ---------- */}
      {/* 멤버십 가이드 */}
      <Route path={route.crew_guide} element={<WritingCrewGuide />} />
      <Route
        path={route.crew_guide_create}
        element={<WritingCrewGuideCreate />}
      />
      <Route path={route.crew_guide_edit} element={<WritingCrewGuideEdit />} />
      {/* 라이팅링크 */}
      <Route path={route.crew_link} element={<WritingLink />} />
      <Route
        path={`${route.crew_link_detail}/:id`}
        element={<WritingLinkDetail />}
      />
    </Routes>
  );
};

export default Router;
